/**
 * @prettier
 * @flow
 */

import { translate } from 'src/utils/translate/translate';

export function translatedTextLabels(): Object {
    return {
        body: {
            noMatch: translate('Sorry, no matching records found'),
            toolTip: translate('Sort'),
            columnHeaderTooltip: column => translate('Sort for @column', { column: column.label }),
        },
        pagination: {
            next: translate('Next Page'),
            previous: translate('Previous Page'),
            rowsPerPage: translate('Rows per page:'),
            displayRows: translate('of'),
        },
        toolbar: {
            search: translate('Search'),
            downloadCsv: translate('Download CSV'),
            print: translate('Print'),
            viewColumns: translate('View Columns'),
            filterTable: translate('Filter Table'),
        },
        filter: {
            all: translate('All'),
            title: translate('FILTERS'),
            reset: translate('RESET'),
        },
        viewColumns: {
            title: translate('Show Columns'),
            titleAria: translate('Show/Hide Table Columns'),
        },
        selectedRows: {
            text: translate('row(s) selected'),
            delete: translate('Delete'),
            deleteAria: translate('Delete Selected Rows'),
        },
    };
}
